import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { Accordion, AccordionSummary, AccordionDetails, Icon } from '@material-ui/core';
import ConfiguracionCorreos from './configuracionCorreos/Correo';
import ConfiguracionUsuarios from './configuracionUsuarios/Usuarios';
import ConfiguracionCobros from './configuracionCobros/Cobro';
import './Configuraciones.css'
import { AuthContext } from "../../context/authContext";
import Personalizacion from './Personalizacion';
import ACCESS from '../../ACCESS';

class ConfiguracionSistema extends Component {

  constructor(props) {
    super(props);

    this.state = {
      secciones: [
        { Componente: ConfiguracionCorreos, titulo: 'Correos', expanded: false, link: '/ConfiguracionSistema#correos', access: [] },
        { Componente: ConfiguracionUsuarios, titulo: 'Usuarios', expanded: false, link: '/ConfiguracionSistema#usuarios', access: [] },
        { Componente: ConfiguracionCobros, titulo: 'Cobros', expanded: false, link: '/ConfiguracionSistema#cobros', access: [] },
        { Componente: Personalizacion, titulo: 'Personalización', expanded: true, link: '/ConfiguracionSistema#personalizacion', access: [] }
      ],
      recursos: []
    };
  }

  componentDidMount() {
    let {
      hasAccess
    } = this.context;

    const validResources = this.state.secciones.filter((sec, i) => hasAccess(sec.access));
    this.setState({
      secciones: validResources
    });
  }

  handleChange = index => () => {
    const { secciones } = this.state;
    secciones[index].expanded = !secciones[index].expanded;
    this.setState({ secciones });
  };

  render() {
    const { secciones } = this.state;
    return (
      <div className="system-config" style={{ margin: '10px' }} >
        {
          secciones.map((seccion, index) => (
            <Accordion key={seccion.titulo} expanded={seccion.expanded} onChange={this.handleChange(index)} className='config-expansion-panel'>
              <AccordionSummary
                className='config-expansion-summary'
                expandIcon={<Icon style={{ color: '#ffffff' }} >expand_more</Icon>}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <div style={{ flex: 1 }} >
                  {seccion.titulo}
                </div>
              </AccordionSummary>
              <AccordionDetails style={{ padding: '0px' }} >
                <seccion.Componente {...this.props} />
              </AccordionDetails>
            </Accordion>
          ))
        }

      </div>
    )
  }
}
ConfiguracionSistema.contextType = AuthContext;
export default withRouter(ConfiguracionSistema)
